import { useState } from "react";
import { List, type ListProps, LoadMoreIndicator, YStack } from "@medbillai/ui";
import type { CaseListFilters, Issue } from "../utils/types";
import { CaseListItem } from "./CaseListItem";
import { EmptyCaseList } from "./EmptyCaseList";
export type CaseListInnerProps = CaseListFilters & {
  issues: Issue[];
  fetchMore: () => Promise<void>;
  loading: boolean;
  endReached: boolean;
  currentIssueId?: string;
  onRefresh?: () => Promise<void>;
  source: string;
  listProps?: Omit<ListProps<Issue>, "data" | "renderItem" | "keyExtractor" | "recycleItems" | "estimatedItemSize" | "onEndReached" | "onEndReachedThreshold" | "children">;
};
export const CaseListInner = ({
  issues,
  fetchMore,
  loading,
  showRead,
  showUnread,
  showClosed,
  endReached,
  currentIssueId,
  onRefresh,
  source,
  listProps
}: CaseListInnerProps) => {
  const [fetchingMore, setFetchingMore] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const isEmpty = issues.length === 0;
  const {
    contentContainerStyle,
    ...restListProps
  } = listProps ?? {};
  const handleFetchMore = async () => {
    if (!fetchingMore && !endReached) {
      setFetchingMore(true);
      await fetchMore();
      setFetchingMore(false);
    }
  };
  const handleRefresh = async () => {
    if (onRefresh && !refreshing) {
      setRefreshing(true);
      await onRefresh();
      setRefreshing(false);
    }
  };
  return <List onRefresh={onRefresh ? () => handleRefresh() : undefined} refreshing={onRefresh ? refreshing : undefined} withDivider data={issues} extraData={currentIssueId} keyExtractor={item => item.id} renderItem={({
    item
  }: {
    item: Issue;
  }) => <CaseListItem issue={item} selected={item.id === currentIssueId} source={source} />} onEndReached={handleFetchMore} onEndReachedThreshold={0.3} contentContainerStyle={[isEmpty ? {
    flexGrow: 1
  } : null, contentContainerStyle]} ListEmptyComponent={<YStack f={1}>
          <EmptyCaseList loading={loading} showRead={showRead} showUnread={showUnread} showClosed={showClosed} />
        </YStack>} ListFooterComponent={isEmpty ? null : <LoadMoreIndicator fetchingMore={fetchingMore} endReached={endReached} noMoreMessage="No more cases" />} {...restListProps} data-sentry-element="List" data-sentry-component="CaseListInner" data-sentry-source-file="CaseListInner.tsx" />;
};